import { render } from "./DropdownItem.vue?vue&type=template&id=338c3bc5&scoped=true"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"

import "../styles/dropdown.scss?vue&type=style&index=0&id=338c3bc5&scoped=true&lang=scss"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338c3bc5"]])

export default __exports__